import React from 'react'
import PropTypes from 'prop-types'
import {rxrPrimaryColor, rxrMediumGreyColor, rxrOrangeColor, rxrRedColor, rxrTintColor, rxrWhiteColor} from '../../assets/styles/color'
import C from './AmenitiesConstants'
import {spaceMedium, spaceSmall} from '../../assets/styles/spacing'
import {makeStyles} from '@mui/styles'
import moment from 'moment'
import {fontSizeSmall} from '../../assets/styles/typography'

function AmenityReservationStatusComponent(props) {
  const classes = useStyles()

  const dynamicColor = (() => {
    switch (props.state) {
      case C.STATE_REQUESTED:
      case C.STATE_NEEDS_RESCHEDULE:
      case C.STATE_VENDOR_NO_SHOW:
      case C.STATE_COMPLETED_DELINQUENT:
      case C.STATE_TIMEDOUT:
        return rxrOrangeColor
      case C.STATE_DECLINED:
        return rxrRedColor
      case C.STATE_CONFIRMED:
      case C.STATE_CONFIRMED_APPROVED:
      case C.STATE_UNDERWAY:
      case C.STATE_COMPLETED:
      case C.STATE_COMPLETED_PAID:
        return rxrPrimaryColor

      case C.STATE_READY_TO_CHARGE:
        return rxrTintColor

      default:
        return rxrMediumGreyColor
    }
  })()

  let stateMetadataCopy = ''
  if (props.updatedAt) {
    stateMetadataCopy = `last modified ${moment(props.updatedAt).format('MMMM Do, YYYY, h:mm a')}`
  }

  return (
    <div className={classes.subTitleContainer}>
      <div className={classes.stateButton} style={{backgroundColor: dynamicColor}}>
        {C.RESERVATION_STATE_LABELS[props.state]}
      </div>
      <div className={classes.stateMetadataCopy}>{stateMetadataCopy}</div>
    </div>
  )
}

const useStyles = makeStyles(() => ({
  subTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spaceMedium,
  },
  stateButton: {
    width: 'fit-content',
    paddingRight: spaceSmall,
    paddingLeft: spaceSmall,
    height: '20px',
    borderRadius: '10px',
    color: rxrWhiteColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stateMetadataCopy: {
    marginLeft: spaceSmall,
    color: rxrPrimaryColor,
    fontSize: fontSizeSmall,
  },
}))

AmenityReservationStatusComponent.propTypes = {
  state: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
}

export default AmenityReservationStatusComponent
